import Phaser from 'phaser';
import { CST } from '../CST';
import $ from 'jquery';
import buttonBehaviours from '../helpers/button-behaviours';
import { hideTextFields, showTextFields } from '../helpers/text-fields';

export default class Login extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.LOGIN);
	}

	preload() {
		this.load.image('bg-login', 'assets/bg-login.png');
		this.load.image('btn-login', 'assets/btn-login.png');
		this.load.image('btn-sign-up', 'assets/btn-sign-up.png');
		this.load.image('btn-reset-password', 'assets/btn-reset-password.png');
		this.load.image('error-account-not-found', 'assets/english/error/error-account-not-found.png');
		this.load.image('error-passwords-not-match', 'assets/english/error/error-passwords-not-match.png');
		this.load.image('error-empty-field', 'assets/english/error/error-empty-field.png');
		this.load.image('error-generic', 'assets/english/error/error-generic.png');
		this.load.html('html-email', 'html/email.html');
		this.load.html('html-password', 'html/password.html');
	}

	create() {
		this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'bg-login');

		this.email = this.add
			.dom(this.cameras.main.width / 2 - 100, this.cameras.main.height / 2 - 125)
			.createFromCache('html-email');
		this.email = this.email.getChildByName('email');

		this.password = this.add
			.dom(this.cameras.main.width / 2 - 100, this.cameras.main.height / 2 + 25)
			.createFromCache('html-password');
		this.password = this.password.getChildByName('password');

		this.btnLogin = this.add
			.image(this.cameras.main.width / 2 - 100, this.cameras.main.height / 2 + 185, 'btn-login')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () =>
				buttonBehaviours.pushOnClick(this, this.btnLogin, () => {
					this.login();
				}),
			);

		this.btnSignUp = this.add
			.image(this.cameras.main.width / 2 + 100, this.cameras.main.height / 2 + 185, 'btn-sign-up')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () =>
				buttonBehaviours.pushOnClick(this, this.btnSignUp, () => {
					this.scene.start(CST.SCENES.REGISTER_CHOOSE);
				}),
			);

		this.btnResetPassword = this.add
			.image(this.cameras.main.width / 2, this.cameras.main.height / 2 + 250, 'btn-reset-password')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () =>
				buttonBehaviours.pushOnClick(this, this.btnResetPassword, () => {
					this.scene.start(CST.SCENES.SENDEMAIL);
				}),
			);
	}

	login() {
		let self = this;

		$.ajax({
			async: false,
			type: 'post',
			url: 'website/login.php',
			data: {
				email: this.email.value,
				password: this.password.value,
			},
			dataType: 'JSON',
			success(response) {
				if (response[0] === 400) {
					hideTextFields([self.email, self.password]);
					buttonBehaviours.disableInteraction([
						self.btnLogin,
						self.btnSignUp,
						self.btnResetPassword,
					]);

					const error = self.add.image(
						self.cameras.main.width / 2,
						self.cameras.main.height / 2 - 175,
						response[1],
					);

					setTimeout(() => {
						showTextFields([self.email, self.password]);
						buttonBehaviours.enableInteraction([
							self.btnLogin,
							self.btnSignUp,
							self.btnResetPassword,
						]);

						error.destroy();
					}, 2000);
				} else {
					if (response[1] === '2fa-required') {
						localStorage.setItem('2fa_email', self.email.value);
						self.scene.start(CST.SCENES.VERIFY2FA);
					} else {
						localStorage.setItem('jwt', response[1]);
						if (response[2]) {
							localStorage.setItem('admin', true);
							self.scene.start(CST.SCENES.MENU);
						} else {
							self.scene.start(CST.SCENES.LICENSEEXPIRED, { isOrg: response[3] });
						}
					}
				}
			},
			error(error) {
				console.log(error);
			},
		}).responseJSON;
	}
}
